module.exports = __webpack_public_path__ + "static/media/arrow-up.03db05cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-up.svg
// module id = 305
// module chunks = 0